import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Target, MessageCircle, BarChart3 } from 'lucide-react';
export function Author() {
  return <section className="py-20 md:py-28 bg-zinc-50 border-y border-zinc-200" data-id="element-58">
      <div className="max-w-5xl mx-auto px-4 md:px-6" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="grid md:grid-cols-3 gap-8 md:gap-12 items-center" data-id="element-60">
          {/* Avatar / Identity */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-61">
            <div className="w-32 h-32 md:w-40 md:h-40 rounded-3xl overflow-hidden shadow-xl mb-5 bg-zinc-200" data-id="element-62">
              <img src="https://cdn.magicpatterns.com/uploads/o7fVLGWKLNLxEXnEaiBoG7/IMG_1517.jpg" alt="Franco Fernández" width={160} height={160} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-63" />
            </div>
            <div data-id="element-64">
              <span className="text-xs font-bold text-blue-600 uppercase tracking-wider block mb-2" data-id="element-65">
                Creador
              </span>
              <h3 className="text-2xl font-bold text-zinc-900 leading-tight" data-id="element-66">
                Franco Fernández
              </h3>
              <p className="text-sm text-zinc-500 mt-1" data-id="element-67">
                Trafficker · Sistemas de anuncios para venta por conversación
              </p>
            </div>
          </div>

          {/* Bio */}
          <div className="md:col-span-2" data-id="element-68">
            <p className="text-lg text-zinc-700 leading-relaxed mb-6" data-id="element-69">
              Trafficker especializado en campañas para negocios que venden por
              conversación. Su enfoque está puesto en sistemas de anuncios para
              tiendas, servicios y productos donde la venta se concreta por
              mensaje, no por una página web tradicional.
            </p>
            <p className="text-lg text-zinc-700 leading-relaxed mb-8" data-id="element-70">
              <span className="font-semibold text-zinc-900" data-id="element-71">
                Sistema iPhone Ads
              </span>{' '}
              nace de trabajar estrategias específicas para tiendas de iPhone,
              analizando productos ganadores, campañas de mensajes, tráfico al
              perfil, contenido publicitario y calidad real de las
              conversaciones.
            </p>

            <div className="grid sm:grid-cols-3 gap-3" data-id="element-72">
              <div className="flex items-start gap-2.5 p-3 bg-white rounded-xl border border-zinc-200" data-id="element-73">
                <Target className="w-5 h-5 text-blue-600 shrink-0 mt-0.5" data-id="element-74" />
                <span className="text-sm font-medium text-zinc-700 leading-snug" data-id="element-75">
                  Campañas pensadas para conversación, no para clicks
                </span>
              </div>
              <div className="flex items-start gap-2.5 p-3 bg-white rounded-xl border border-zinc-200" data-id="element-76">
                <MessageCircle className="w-5 h-5 text-blue-600 shrink-0 mt-0.5" data-id="element-77" />
                <span className="text-sm font-medium text-zinc-700 leading-snug" data-id="element-78">
                  Análisis real de mensajes recibidos
                </span>
              </div>
              <div className="flex items-start gap-2.5 p-3 bg-white rounded-xl border border-zinc-200" data-id="element-79">
                <BarChart3 className="w-5 h-5 text-blue-600 shrink-0 mt-0.5" data-id="element-80" />
                <span className="text-sm font-medium text-zinc-700 leading-snug" data-id="element-81">
                  Decisiones basadas en datos, no en intuición
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}